const defaultApiUrl = "https://api.apex-charts.com:4770";
const defaultSocketUrl = "https://api.apex-charts.com:4770";

const getApiUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

const getSocketUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

module.exports = {
	apiUrl: defaultApiUrl,
	socketUrl: defaultSocketUrl,
	getApiUrl,
	getSocketUrl,
};
